<template>
    <div class="text-center">
      <v-dialog dark v-model="dialog" width="500"> 

        <v-card>
        <v-card-title class="text-h5" style="background-color: #161d30;">
            <p class="text-center ma-0"> Comprobando si hay caja abierta...  </p>
        </v-card-title>

        <v-card-text style="background-color: #283045;">
            <v-progress-linear v-if="loading" indeterminate color="green darken-2" class="my-4"></v-progress-linear>
        </v-card-text> 
      </v-card>
  
        
      </v-dialog>

      <registrar ref="refagregar" v-on:success="()=>{}"/>
      <abierta ref="refabierta" v-on:success="()=>{}"/>
    </div>
  </template>

<script>
import xaxios from '@/xaxios';
import registrar from './registrar.vue';
import abierta from './caja-abierta.vue';

export default {
  data () {
    return {
      dialog: false,
      valid: true,
      loading: false,
      
    }
  }, 
  components:{registrar,abierta}, 

  methods: {
    openmodal(){
        this.dialog = true; 
        this.verificar();
    },
       

      async verificar(){
        this.msg = ''; 
        this.loading = true;

        const sedeid = this.$store.state.CARGO.sede.id;
        const userid = this.$store.state.DATA_USER.id;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/abierto/${sedeid}/usuario/${userid}`; 
        const res = await xaxios.get(url).then(x=>x).catch(x=>x); 
        if(res && res.data){
            const data = res.data;
            // window.console.log('res:', data); 
            this.$refs.refabierta.openmodal(data);
            this.$store.state.cajaperturada = true;
          }else{
            this.$refs.refagregar.openmodal();
            this.$store.state.cajaperturada = false;
        }
        
        this.dialog = false;
        this.loading = false;
      },

      msgErr(res){ 
        try{ this.msg = res.response.data.data; }
        catch(e){ this.msg = res }
        
      }
    },
}
</script>